module.exports = __webpack_public_path__ + "static/media/BackgroundLeft.5e092627.png";